// extracted by mini-css-extract-plugin
module.exports = {"container":"SHqfsv_2GS","logo-container":"_8ZfFihtUo-","logoContainer":"_8ZfFihtUo-","logo":"_7T8u3XAzqF","secondary-logo":"_2BljZFi77V","secondaryLogo":"_2BljZFi77V","secondary-logo-container":"_1UPQzWXzUL","secondaryLogoContainer":"_1UPQzWXzUL","vertical":"_2wQyrbJB6d","custom-branding":"_4Z1FHuMULn","customBranding":"_4Z1FHuMULn"};
    if(module.hot) {
      // 1597843239351
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  